// extracted by mini-css-extract-plugin
module.exports = {"item":"MobileRectangleButton_item__MJoYe","b2b":"MobileRectangleButton_b2b__DjcgW","icon":"MobileRectangleButton_icon__djMBD","link":"MobileRectangleButton_link__PjW_N"};